import setNotificationModelsMissingFields from './setNotificationModelsMissingFields';

const processNotifications = (resources, Model) => {
  const notifications = resources?.map((item) => new Model(item));

  return setNotificationModelsMissingFields(notifications);
};

export default processNotifications;
